import { render, staticRenderFns } from "./home-mcp-announcement.component.vue?vue&type=template&id=6e4408fe&scoped=true&"
import script from "./home-mcp-announcement.component.vue?vue&type=script&lang=ts&"
export * from "./home-mcp-announcement.component.vue?vue&type=script&lang=ts&"
import style0 from "./home-mcp-announcement.component.vue?vue&type=style&index=0&id=6e4408fe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4408fe",
  null
  
)

export default component.exports